<template>
  <div class="col-lg-3 col-sm-4">
    <div class="card">
      <div
        slot="header"
        class="server-card_header"
      >
        <span class="mdi mdi-folder-multiple">

          <small class="server-card_header_small">
            {{ translate('group.one') }}:
          </small>

          <span v-if="edit_title">
            <fg-input
              v-model="group.name"
              style="display: inline-block"
              type="text"
              @focusout="save_title"
            />
            <button href="#" class="btn btn-success" @click="save_title" >
              Save
            </button>
          </span>

          <span v-if="!edit_title">
            {{ group.name }}
            <span class="mdi mdi-border-color" @click="edit_toggle"/>
          </span>
        </span>
      </div>
      <div class="server-card_footer">
        <span
          class="btn btn-danger"
          @click="deleteGroup"
        >{{ translate('group.del') }} </span>
      </div>
    </div>
  </div>
</template>
<script>

import SisSelect from 'components/UIComponents/Inputs/SisSelect.vue'
import GlobalConfirm from "components/UIComponents/Confirm/GlobalConfirm.vue";

export default {
  name: 'ServerGroupItem',
  components: {
    SisSelect
  },
  props: {
    group: Object
  },
  data () {
    return {
      add_serv: false,
      edit_title: false,
      addServer: [],
      servers: this.group.servers
    }
  },
  watch: {
    group () {
      this.servers = this.group.servers
    },
  },
  methods: {
    edit_toggle () {
      this.edit_title = !this.edit_title
    },
    save_title () {
      this.edit_title = false
      this.save()
    },
    save () {
      this.$http.v1.saveServerGroup(this.group, () => {
        this.global_notify('info', this.translate('server.group_save'))
        this.$emit('update_servers_group')
      })
    },
    deleteGroup () {
      let t = this.$createElement(GlobalConfirm, {
        props: {
          text: this.translate('server.delete.group') + '?'
        },
        on: {
          close: () => {
            this.$modal.hide('delete_server_group')
          },
          confirm: () => {
            this.$emit('del_group', this.group.id)
            this.$modal.hide('delete_server_group')
          }
        }
      })
      let temp = { render () { return t } }
      this.$modal.show(temp, {}, {height: 'auto', adaptive: true, clickToClose: false, scrollable: true, name: 'delete_server_group'})
    },
  }
}
</script>
